import React from 'react';
import './MyWork.css';
import { GiSwordWound, GiScrollUnfurled, GiCrownCoin, GiTrophy } from 'react-icons/gi';
import { MdOutlineAutoAwesome, MdOutlinePsychology } from 'react-icons/md';

function MyWork() {
  return (
    <div className="mywork-screen">
      {/* Hero Section */}
      <div className="container-fluid py-5 d-flex align-items-center min-vh-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="content-wrapper">
                <h1 className="font-big slide-in-top">
                  Divine <span className="animate-charcter">Creations</span>
                </h1>
                <div className="gold-bar mb-4 slide-in-bottom"></div>
                <p className="lead-text slide-in-bottom">
                  A collection of Kara's most legendary works and adventures. Each piece tells a story of divine creativity
                  and the art of chaos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Works */}
      <div className="container-fluid featured-works py-5">
        <div className="container">
          <h2 className="section-title text-center mb-5 slide-in-bottom">Featured Adventures</h2>
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="work-card slide-in-bottom">
                <div className="work-image">
                  <img src="../images/eternal-dagger.jpg" alt="Eternal Dagger" />
                </div>
                <div className="work-content">
                  <GiSwordWound className="work-icon" />
                  <h3>The Eternal Dagger</h3>
                  <p>A legendary weapon forged from celestial metal, capable of cutting through reality itself.</p>
                  <div className="work-tags">
                    <span>Weapon</span>
                    <span>Legendary</span>
                    <span>Divine</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="work-card slide-in-bottom">
                <div className="work-image">
                  <img src="../images/chaos-realm.jpg" alt="Chaos Realm" />
                </div>
                <div className="work-content">
                  <GiCrownCoin className="work-icon" />
                  <h3>The Chaos Realm</h3>
                  <p>A dimension where creativity knows no bounds, home to the most extraordinary beings.</p>
                  <div className="work-tags">
                    <span>Realm</span>
                    <span>Creation</span>
                    <span>Divine</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="work-card slide-in-bottom">
                <div className="work-image">
                  <img src="../images/reality-warp.jpg" alt="Reality Warp" />
                </div>
                <div className="work-content">
                  <MdOutlineAutoAwesome className="work-icon" />
                  <h3>Reality Warp</h3>
                  <p>A spell that bends the fabric of reality, creating new possibilities and dimensions.</p>
                  <div className="work-tags">
                    <span>Magic</span>
                    <span>Divine</span>
                    <span>Power</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Creative Process */}
      <div className="container-fluid process-section py-5">
        <div className="container">
          <h2 className="section-title text-center mb-5 slide-in-bottom">The Creative Process</h2>
          <div className="row g-4">
            <div className="col-md-6 col-lg-3">
              <div className="process-card slide-in-bottom">
                <div className="process-number">01</div>
                <h3>Inspiration</h3>
                <p>Drawing from the depths of Norse mythology and divine imagination.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="process-card slide-in-bottom">
                <div className="process-number">02</div>
                <h3>Creation</h3>
                <p>Weaving magic and chaos into tangible forms of power and beauty.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="process-card slide-in-bottom">
                <div className="process-number">03</div>
                <h3>Refinement</h3>
                <p>Perfecting each creation through divine craftsmanship and attention to detail.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="process-card slide-in-bottom">
                <div className="process-number">04</div>
                <h3>Legacy</h3>
                <p>Ensuring each creation leaves its mark on the realms of existence.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className="container-fluid gallery-section py-5">
        <div className="container">
          <h2 className="section-title text-center mb-5 slide-in-bottom">Divine Gallery</h2>
          <div className="gallery-grid">
            <div className="gallery-item slide-in-bottom">
              <img src="../images/gallery-1.jpg" alt="Divine Creation 1" />
              <div className="gallery-overlay">
                <h4>The First Spark</h4>
                <p>The beginning of divine creation</p>
              </div>
            </div>
            <div className="gallery-item slide-in-bottom">
              <img src="../images/gallery-2.jpg" alt="Divine Creation 2" />
              <div className="gallery-overlay">
                <h4>Realm of Chaos</h4>
                <p>Where creativity knows no bounds</p>
              </div>
            </div>
            <div className="gallery-item slide-in-bottom">
              <img src="../images/gallery-3.jpg" alt="Divine Creation 3" />
              <div className="gallery-overlay">
                <h4>Divine Weapons</h4>
                <p>Tools of power and destruction</p>
              </div>
            </div>
            <div className="gallery-item slide-in-bottom">
              <img src="../images/gallery-4.jpg" alt="Divine Creation 4" />
              <div className="gallery-overlay">
                <h4>Mythical Beings</h4>
                <p>Creatures of legend and lore</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyWork;